import React from "react";
import { Card } from "antd";
import Footer from "../Footer";
import PublicHeader from "../Header/PublicHeader";
import { Link } from "react-router-dom";

const Refund = () => {
  return (
    <>
    <PublicHeader />
    <div className="container mx-auto p-6">
      <div className=" container  rounded-lg p-6 text-justify mx-auto" style={{ textWrap: 'pretty' }}>
        <h1 className="text-3xl font-bold mb-4 text-center text-[#0d73b9]">
          Refund & Cancellation Policy
        </h1>
        <p className="text-gray-600  mb-6">
          At the <strong>Association of Professional Career Counsellors of India (APCCI)</strong>, 
          we are committed to providing high-quality services to support career counsellors across the country.
          Please review our <span className="font-semibold">Refund & Cancellation Policy</span> before making any payments.
        </p>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2 text-blue-700">
            1. Non-Refundable Services
          </h2>
          <p className="text-gray-700">
            All payments made towards the following services are <strong>non-refundable</strong>:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2">
            <li>Membership fees</li>
            <li>Event registrations (including conferences, workshops, and networking sessions)</li>
            <li>Training programs and certifications</li>
            <li>Publications, research reports, or any digital resources</li>
            <li>Any other services offered by APCCI</li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2 text-blue-700">
            2. Cancellation Policy
          </h2>
          <ul className="list-disc list-inside text-gray-700">
            <li>
              <strong>Membership & Services:</strong> Once a membership or service is purchased, 
              it cannot be cancelled or transferred.
            </li>
            <li>
              <strong>Event Registrations:</strong> If an event is cancelled by APCCI, 
              registered participants will be notified, and any applicable adjustments 
              will be made at APCCI’s discretion.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Contact Us</h2>
          <p className="text-gray-700">
            For any queries regarding this policy, please reach out to us at:
          </p>
         <p >Email:<b> dgoffice@apcci.in </b></p>
                   <p className="font-semibold">
           Or click to <Link to="/contact-us" className="text-blue-500 underline">Contact us</Link>
         </p>
        </div>

        <p className="text-gray-700 text-center mt-6">
          We appreciate your understanding and support in building a strong professional community.
        </p>

        <p className="text-center font-bold mt-4">
          - Association of Professional Career Counsellors of India (APCCI)
        </p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default Refund;
